module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 29
// module chunks = 0